import styled from "styled-components";

// Distance + time of the route shown: a dark pill centred at the bottom of
// the open map, its two values centred as one row with a fixed gap.
export const DirectionsInfos = styled.div`
  pointer-events: none;
  user-select: none;
  position: absolute;
  z-index: 10000000000000;
  left: 50%;
  bottom: 50px;
  transform: translateX(-50%);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  gap: 28px;
  box-sizing: border-box;
  min-width: 327px;
  height: 74px;
  padding: 0 40px;

  background: #141414;
  border-radius: 1000px;
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  &.in {
    opacity: 1;
    transition: all 1s ease-in-out 0.5s;
  }
`;

const value = `
  display: block;
  font-family: var(--app-font-family, "DM Sans", sans-serif);
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 1;
  white-space: nowrap;
`;

export const DirectionsInfosDistance = styled.div`
  ${value}
  color: #ffffff;
`;

export const DirectionsInfosTime = styled.div`
  ${value}
  color: #4cd964;
`;
